<!-- Input field with ngbDate picker component -->
<div [class.disabled-container]="isDisabled">
	<div
		class="input-group date-control"
		[class.is-open]="datePicker.isOpen()"
	>
		<input
			class="form-control"
			[class.text-start]="textAlign === EnumNgDatePickerTextAlignMent.Start"
			[class.text-center]="textAlign === EnumNgDatePickerTextAlignMent.Center"
			[class.text-end]="textAlign === EnumNgDatePickerTextAlignMent.End"
			[id]="id"
			role="button"
			ngbDatepicker
			container="body"
			datepickerClass="ui-v2-datepicker"
			[restoreFocus]="focusRestoreTarget"
			placement="bottom-start top-start"
			#datePicker="ngbDatepicker"
			navigation="arrows"
			[footerTemplate]="calendarNavigation"
			placeholder="yyyy-mm-dd"
			name="schedule-upload-input"
			[ngModel]="value! | ngDatePipe"
			(ngModelChange)="emitDate($event)"
			[minDate]="options!.minDate | ngDatePipe"
			[maxDate]="options!.maxDate | ngDatePipe"
			[markDisabled]="disableDates"
			[disabled]="isDisabled"
			[attr.aria-expanded]="datePicker.isOpen()"
			aria-haspopup="dialog"
			(navigate)="syncCalendarNavigation($event)"
			(closed)="onTouched()"
			(click)="toggleCalendar(datePicker)"
			readonly
		/>

		<!-- Date picker button -->
		<button
			class="btn btn-outline-primary calendar calender-btn"
			[class.is-open]="datePicker.isOpen()"
			[disabled]="isDisabled"
			type="button"
			(click)="toggleCalendar(datePicker)"
			[attr.aria-expanded]="datePicker.isOpen()"
			aria-haspopup="dialog"
			aria-label="Open date calendar"
		>
			<ng-fa-icon icon="calendar-days"></ng-fa-icon>
		</button>
	</div>
</div>

<ng-template #calendarNavigation>
	<div class="ui-v2-calendar-navigation">
		<ng-custom-dropdown
			[ngModel]="calendarMonth"
			(ngModelChange)="navigateCalendar(datePicker, $event, calendarYear)"
			[ngModelOptions]="{ standalone: true }"
			[options]="calendarMonthOptions"
			[onlyText]="true"
			[closeOnScroll]="false"
			[container]="null"
			display="static"
			dropdownClass="ui-v2-calendar-menu"
			[elementId]="id + '-month'"
		></ng-custom-dropdown>

		<ng-custom-dropdown
			[ngModel]="calendarYear"
			(ngModelChange)="navigateCalendar(datePicker, calendarMonth, $event)"
			[ngModelOptions]="{ standalone: true }"
			[options]="calendarYearOptions"
			[onlyText]="true"
			[closeOnScroll]="false"
			[container]="null"
			display="static"
			dropdownClass="ui-v2-calendar-menu"
			[elementId]="id + '-year'"
		></ng-custom-dropdown>
	</div>
</ng-template>
